export default __webpack_public_path__ + "static/media/Mahabalipuram05.540fad57.jpg";